import { render, staticRenderFns } from "./RequestDemo.vue?vue&type=template&id=8ffcf126&scoped=true&"
import script from "./RequestDemo.vue?vue&type=script&lang=ts&"
export * from "./RequestDemo.vue?vue&type=script&lang=ts&"
import style0 from "./RequestDemo.vue?vue&type=style&index=0&id=8ffcf126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffcf126",
  null
  
)

export default component.exports